/* eslint-disable */
export const initAnalytics = () => {
  const heapAnalytics = function () {
    window.heap = window.heap || [];

    window.heap.load = function (e: '3049634841', t: any) {
      window.heap.appid = e;
      window.heap.config = t = t || {};
      // @ts-ignore
      let _r = t.forceSSL || 'https:' === document.location.protocol;
      let a = document.createElement('script');
      a.type = 'text/javascript';
      a.async = !0;
      a.src = `https://cdn.heapanalytics.com/js/heap-${e}.js`;
      let n = document.getElementsByTagName('script')[0];
      n?.parentNode?.insertBefore(a, n);
      for (
        var o = function (e: any) {
            return function () {
              window.heap.push(
                [e].concat(Array.prototype.slice.call(arguments, 0)),
              );
            };
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'resetIdentity',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          c = 0;
        c < p.length;
        c++
      )
        window.heap[p[c]] = o(p[c]);
    };
    window.heap.load('3049634841');
  };

  heapAnalytics();
};
